import { createSlice } from '@reduxjs/toolkit';
import _sortBy from 'lodash/sortBy';

import albumsDataRaw from 'data/albums.json';
import songsDataRaw from 'data/songs.json';

import { AlbumState, Album, Song } from 'interfaces';

const initialStateDefault: AlbumState = {
  albums: [],
  albumDetails: null,
  albumNumber: null,
  songs: [],
  singles: []
};

const albumsData: Album[] = albumsDataRaw as unknown as Album[];
const songsData: Song[] = songsDataRaw as unknown as Song[];

const albumSlice = createSlice({
  name: 'albums',
  initialState: initialStateDefault,
  reducers: {
    loadAlbums (state) {
      return {
        ...state,
        albums: albumsData
      };
    },
    getAlbumDetails (state, action) {
      const { albumId, international } = action.payload;

      const albumDetails = albumsData.filter((el) => el.id === albumId && el.international === international)[0];
      const sameTypeAlbum = albumsData.filter((el) => el.international === albumDetails.international && el.typeId === albumDetails.typeId);
      const albumNumberIndex = sameTypeAlbum.findIndex(i => i.id === albumDetails.id);
      const songs = international
        ? songsData
          .filter((el) => el.albumId === albumDetails.id && el.albumSongOrder !== null && el.isOnlyJapanese === undefined)
        : songsData
          .filter((el) => el.albumId === albumDetails.id && el.albumSongOrder !== null && el.isOnlyInternational === undefined)
      ;
      const singles = international
        ? songsData
          .filter((el) => el.albumId === albumDetails.id && el.single === true && el.isOnlyJapanese === undefined)
          .map((el) => ({ ...el, releaseDate: el.singleRelease || albumDetails.releaseDate }))
        : songsData
          .filter((el) => el.albumId === albumDetails.id && el.single === true && el.isOnlyInternational === undefined)
          .map((el) => ({ ...el, releaseDate: el.singleRelease || albumDetails.releaseDate }));

      const sortedSingles = _sortBy(singles, 'releaseDate');

      return {
        ...state,
        albums: albumsData,
        albumNumber: albumNumberIndex + 1,
        albumDetails,
        songs,
        singles: sortedSingles
      };
    }
  }
});

export const { loadAlbums, getAlbumDetails } = albumSlice.actions;

export default albumSlice.reducer;
